var React = require('react');

function Code (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m8.57 20.9601c.07.03.14.04.21.04.24 0 .46-.15.56-.39l6.45-16.80005c.11-.31-.04-.66-.35-.78-.3-.11-.65.04-.77.35l-6.45 16.80005c-.11.31.04.66.35.78zm-1.56993-2.96c-.15 0-.31-.06-.42-.18l-5.4-5.4c-.230002-.23-.230002-.61 0-.85l5.4-5.40004c.23-.23.61-.23.85 0 .23.23.23.61 0 .85l-4.98 4.98004 4.98 4.98c.23.23.23.61 0 .85-.12.11-.28.17-.43.17zm9.99993 0c-.15 0-.31-.06-.42-.18-.23-.23-.23-.61 0-.85l4.97-4.97-4.98-4.98004c-.23-.23-.23-.61 0-.85.24-.23.62-.23.85 0l5.4 5.40004c.23.23.23.61 0 .85l-5.4 5.4c-.11.12-.27.18-.42.18z"}));
}

Code.defaultProps = {"fill":"currentColor","viewBox":"0 0 24 24"};

module.exports = Code;

Code.default = Code;
